import RentalHistory from './RentalHistory'

export default RentalHistory
